export default __webpack_public_path__ + "static/apply-footer-76c54d330acfa1be96c46683c60ea536.png";